import { useCallback, useRef, useState } from "react";

// Shared double-submit guard: forms across the app each rolled their own
// isSubmitting/isSaving boolean; this centralizes the pattern so a second
// click while a request is in flight is a structural no-op, not something
// every component has to remember to check.
export function useSubmitGuard() {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const isSubmittingRef = useRef(false);

  const guardedSubmit = useCallback((asyncFn) => {
    return async (...args) => {
      if (isSubmittingRef.current) return;
      isSubmittingRef.current = true;
      setIsSubmitting(true);
      try {
        return await asyncFn(...args);
      } finally {
        isSubmittingRef.current = false;
        setIsSubmitting(false);
      }
    };
  }, []);

  return { isSubmitting, guardedSubmit };
}

export default useSubmitGuard;
